import React from 'react';
import BossDialog from '../../components/BossDialog';
import { ADS_TYPE} from '../../framework/constant/constant';
import IconSquareButton from '../../framework/forms/helpercomponents/buttons/IconSquareButton';
import { useTranslation } from '../../locale/useTranslation';

const SMChannelIconForm = ({ handleCancel, handleSelectedChannel }) => {

    const lang = useTranslation();

    const channelConfigs = [
        { type: ADS_TYPE.META, label: lang.meta_label, icon: 'fa fa-facebook', color: '#4267B2' },
        { type: ADS_TYPE.GOOGLE, label: lang.google_label, icon: 'fa fa-google', color: '#EA4335' },
        { type: ADS_TYPE.LINKEDIN, label: lang.linkedin_label, icon: 'fa fa-linkedin', color: '#0077B5' },
        { type: ADS_TYPE.YOUTUBE, label: lang.youtube_label, icon: 'fa fa-youtube', color: '#FF0000' },
        { type: ADS_TYPE.SNAPCHAT, label: lang.snapchat_label, icon: 'fab fa-snapchat-ghost', color: '#FFFC00', textColor: '#000' },
    ];

    return (
        <BossDialog title={lang.social_media_channel_type_header} onClose={handleCancel} width="400px">
                <div style={{ display: 'grid', gridTemplateColumns: "1fr 1fr 1fr", gap: "8px" }}>
                    {channelConfigs.map((channel) => (
                        <IconSquareButton
                            key={channel.type}
                            name={channel.label}
                            title={channel.label}
                            width={'70px'}
                            height={'70px'}
                            borderRadius={'10px'}
                            icon={channel.icon}
                            iconSize={'36px'}
                            backgroundColor={channel.color}
                            color={channel.textColor || '#fff'}
                            onClick={() => handleSelectedChannel(channel.type)}
                        />
                    ))}
                </div>
        </BossDialog>
    );
};

export default SMChannelIconForm;




